import { alpha, Box, styled } from "@mui/material";

interface IStyledObjectiveCardProps {
    fullWidth?: boolean;
    fullHeight?: boolean;
    compact?: boolean;
    selected?: boolean;
}

const StyledObjectiveCard = styled(Box, {
    shouldForwardProp: (prop) =>
        !["fullWidth", "fullHeight", "compact", "selected"].includes(prop as string),
})<IStyledObjectiveCardProps>(({ theme, fullWidth, fullHeight, compact, selected }) => ({
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(compact ? 1.5 : 2),
    boxSizing: "border-box",
    borderRadius: (theme as any).shape.border.general.radius[4],
    backgroundColor: selected
        ? alpha(theme.palette.primary.main, 0.1)
        : (theme as any).palette.neutral.darkest,
    border: selected
        ? `2px solid ${theme.palette.primary.main}`
        : "2px solid rgba(255, 255, 255, 0.06)",
    width: fullWidth ? "100%" : "280px",
    maxWidth: fullWidth ? "100%" : "280px",
    boxShadow: selected ? theme.shadows[6] : theme.shadows[4],
    height: fullHeight ? "100%" : "auto",
    transition: theme.transitions.create(["box-shadow", "border-color", "background-color"], {
        duration: theme.transitions.duration.short,
    }),
}))

export { StyledObjectiveCard }
export type { IStyledObjectiveCardProps }